
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation('partnership');

  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white pt-24 pb-12 md:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <div className="inline-flex items-center bg-gold-600/20 backdrop-blur-sm border border-gold-500/30 rounded-full px-3 py-1 md:px-4 md:py-2 mb-4 md:mb-8">
            <i className="ri-vip-crown-line text-gold-400 mr-1.5 md:mr-2 text-xs md:text-base"></i>
            <span className="text-gold-300 font-semibold text-[10px] md:text-sm">{t('hero.badge')}</span>
          </div>

          <h1 className="text-2xl md:text-5xl lg:text-6xl font-bold mb-3 md:mb-6 font-serif leading-tight">
            {t('hero.title')}
          </h1>
          <p className="text-xs md:text-xl text-gray-300 max-w-3xl mx-auto mb-6 md:mb-10 leading-relaxed px-2 md:px-4">
            {t('hero.description')}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center px-4">
            <a
              href="#form"
              className="w-full sm:w-auto px-5 md:px-8 py-2.5 md:py-4 bg-gold-600 text-white font-semibold rounded-lg hover:bg-gold-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-xs md:text-base"
            >
              {t('hero.ctaPrimary')}
            </a>
            <a
              href="#benefits"
              className="w-full sm:w-auto px-5 md:px-8 py-2.5 md:py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition-all duration-300 border border-white/20 whitespace-nowrap cursor-pointer text-xs md:text-base"
            >
              {t('hero.ctaSecondary')}
            </a>
          </div>

          <div className="grid grid-cols-3 gap-2 md:gap-8 mt-8 md:mt-16 max-w-3xl mx-auto px-2 md:px-4">
            <div className="bg-white/5 backdrop-blur-sm rounded-lg md:rounded-xl px-2 py-3 md:p-6 border border-white/10">
              <div className="text-xl md:text-4xl font-bold text-gold-400 mb-0.5 md:mb-2">{t('hero.stats.commission.value')}</div>
              <div className="text-[10px] md:text-sm text-gray-400">{t('hero.stats.commission.label')}</div>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-lg md:rounded-xl px-2 py-3 md:p-6 border border-white/10">
              <div className="text-xl md:text-4xl font-bold text-gold-400 mb-0.5 md:mb-2">{t('hero.stats.support.value')}</div>
              <div className="text-[10px] md:text-sm text-gray-400">{t('hero.stats.support.label')}</div>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-lg md:rounded-xl px-2 py-3 md:p-6 border border-white/10">
              <div className="text-xl md:text-4xl font-bold text-gold-400 mb-0.5 md:mb-2">{t('hero.stats.experience.value')}</div>
              <div className="text-[10px] md:text-sm text-gray-400">{t('hero.stats.experience.label')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
